import useHttpProvider from "@/common/hooks/use-http";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import { Promotion } from "@/features/giveaways/models/giveaway";
import * as GiveawaysService from "@/features/giveaways/services/giveaways";
import { GiveawayDetailsRoute } from "@/features/home/route";
import * as SubscriptionServices from "@/features/payments/services/subscriptions";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function ProfileCurrentEntriesPage() {
	const navigate = useNavigate();

	const { http } = useHttpProvider();
	const [currentPromotions, setCurrentPromotions] = useState<Promotion[]>([]);
	const [hasActiveSubscription, setHasActiveSubscription] = useState<boolean>(false);

	const getCurrentPromotions = async () => {
		try {
			// Check if user has active subscription
			const subscriptionData = await SubscriptionServices.getUserActiveSubscription(http);
			const hasSubscription = subscriptionData && subscriptionData.subscription;
			setHasActiveSubscription(!!hasSubscription);

			if (hasSubscription) {
				const response = await GiveawaysService.getActivePromotions(http);
				setCurrentPromotions(response);
			} else {
				const response = await GiveawaysService.getUserDrawsWithEntryCount(http);
				setCurrentPromotions(response);
			}
		} catch (error) {
			const response = await GiveawaysService.getUserDrawsWithEntryCount(http);
			setCurrentPromotions(response);
			setHasActiveSubscription(false);
		}
	};

	useEffect(() => {
		getCurrentPromotions();
	}, []);

	return (
		<div className="flex flex-col gap-8">
			<h1 className="web-heading-h3-medium">Your Current Entries</h1>

			<Table>
				<TableHeader className="rounded-[32px] border-0 bg-[rgba(46,_72,_219,_0.05)]">
					<TableRow className="border-0!">
						<TableHead className="web-body-b1 rounded-l-[32px] p-4 text-gray-500">
							ID
						</TableHead>
						<TableHead className="web-body-b1 p-4 text-gray-500">
							Draw Name
						</TableHead>
						<TableHead className="web-body-b1 p-4 text-gray-500">
							{hasActiveSubscription ? "Access Type" : "Your Entries"}
						</TableHead>
						<TableHead className="web-body-b1 rounded-r-[32px] p-4 text-gray-500">
							Draw Date
						</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{currentPromotions.map((currentPromotion) => (
						<TableRow key={currentPromotion.id} className="border-0">
							<TableCell className="web-body-b1 rounded-l-[32px] px-4 text-left">
								{currentPromotion.id}
							</TableCell>
							<TableCell className="px-4 text-left">
								<div className="flex flex-row gap-2">
									<p
										className="web-body-b1 cursor-pointer text-blue-700 underline"
										onClick={() =>
											navigate(
												GiveawayDetailsRoute + "?id=" + currentPromotion.id
											)
										}
									>
										{currentPromotion.prize.title}
									</p>
								</div>
							</TableCell>
							<TableCell className="px-4 text-left">
								<p className="web-body-b1">
									{hasActiveSubscription 
										? "Subscription Access" 
										: `${currentPromotion.totalEntries || 0} entries`}
								</p>
							</TableCell>
							<TableCell className="flex flex-col gap-2 px-4 py-6 text-left">
								<p className="web-body-b1">
									{new Intl.DateTimeFormat("en-GB").format(
										new Date(currentPromotion.endDate)
									)}
								</p>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
}

export default ProfileCurrentEntriesPage;
